import { AccessPlanPagination } from '../model/access_plan_pagination';
import { FetchAccessPlanRepository } from './../../data/repository/fetch_access_plan_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/access_plan';

export interface FetchAccessPlanUseCase {
    (pagination: DataOptions, search: string): Promise<AccessPlanPagination>
}

const fetchAccessPlanUseCase = (repository: FetchAccessPlanRepository): FetchAccessPlanUseCase => async (pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchAccessPlanUseCase;